import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Frequently Asked Questions | Ship&Play',
  description:
    'Get quick answers to the most frequently asked questions about Ship&Play. ' +
    'Learn how door-to-door luggage and travel-gear shipping works, what you can ship, ' +
    'international guidelines, and more.',
  alternates: {
    canonical: 'https://www.shipplay.com/faq',
  },
}

export default metadata
